import { gql } from '@apollo/client';

const Fragments = {
  incomeSource: gql`
    fragment incomeSource on IncomeSource {
      id
      orderNo
      code
      name
      incomeSourceArea
      isActive
    }
  `
};

export default Fragments;
